import { useParams } from 'react-router-dom';
import Panel from '../../../../common/layout/Panel'
import DataResource from '../../../../common/v4/DataResource';

const ClientAccountNumbers = () => {
    const { account_id } = useParams();
    const data = {
        url: `/admin/clients/clients/${account_id}/numbers`,
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: false,
        userFilterSimple: true,
        onclick: 'link',
        link: `/clients/clients/${account_id}/numbers/{id}/edit`,
        metadata: [
            {
                source: 'id',
                label: 'Number',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                source: 'number',
                label: 'Number',
                type: 'text',
            },
            {
                source: 'capabilities',
                label: 'Capabilities',
                type: 'text',
            },
            {
                source: 'smpp_account',
                label: 'SMPP Account',
                type: 'component',
                component: (smppAccount) => smppAccount?.ATRUSERNAME || '-',
            },
            {
                source: 'status',
                label: 'Enabled',
                type: 'boolean',
            },
            {
                type: 'delete',
                label: 'Delete',
            }
        ]
    }
    return (
       <Panel title = "Numbers">
            <DataResource
                addButtonText = "Create Number"
                addButtonLink = {`/clients/clients/${account_id}/numbers/create`}                    
                data = {data}
            />
        </Panel>
    )
}

export default ClientAccountNumbers;